<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    :loading="isLoading"
    routeback="/fornecedor/comercial/segmento-cliente"
  >
    <h4 class="text-center">Dados básicos</h4>
    <LineDivider></LineDivider>
    <FormField
      label="Nome do Segmento"
      v-model="form.nome"
      :validation="$v.form.nome"
    />
    <LineDivider><h4>IDs dos segmentos no ERP</h4></LineDivider>
    <v-row no-gutters v-for="(s, i) in form.segmentoserp" :key="i">
      <v-col class="mr-3">
        <FormField v-model="form.segmentoserp[i]" />
      </v-col>
      <v-col cols="auto">
        <FormButton type="error" @click="removeIDERP(i)">
          <v-icon size="18">fa-trash-alt</v-icon>
        </FormButton>
      </v-col>
    </v-row>
    <FormButton class="ml-auto" text="Adicionar ID do ERP" @click="addIDERP" />

    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import LineDivider from "@/components/LineDivider";
import FormField from "@/components/form/FormField";
import FormButton from "@/components/form/FormButton";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { SEGMENTO_CREATE, SEGMENTO_LOAD } from "@/store/actions/segmento";

export default {
  name: "SegmentoClienteForm",
  components: {
    SidePopup,
    LineDivider,
    FormField,
    FormButton
  },
  data: () => ({
    mode: "add",
    isLoading: false,
    form: {
      segmentoserp: []
    }
  }),
  validations: {
    form: {
      nome: { required }
    }
  },
  methods: {
    onClose(routeBack = false) {
      this.isLoading = false;
      this.$emit("close");
      if (routeBack) {
        this.$router.replace("/fornecedor/comercial/segmento-cliente");
      }
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.isLoading = true;
      let segmento = {
        ...this.form,
        segmentoserp: (this.form.segmentoserp || []).filter(s => s && s != "")
      };
      let msgSucesso = "Segmento criado com sucesso";
      let msgErro = "Falha ao criar um novo segmento";
      if (this.mode == "edit" && segmento.idsegmentocliente) {
        msgSucesso = "Segmento atualizado com sucesso";
        msgErro = "Falha ao atualizar o segmento";
      }
      this.$store
        .dispatch(SEGMENTO_CREATE, segmento)
        .then(() => {
          this.$vueOnToast.pop("success", msgSucesso);
          this.onClose(true);
        })
        .catch(err => {
          const erro = err.response.data.Mensagem || err.response || msgErro;
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    getData(idsegmentocliente) {
      this.isLoading = true;
      this.$store
        .dispatch(SEGMENTO_LOAD, idsegmentocliente)
        .then(data => {
          this.form = {
            ...data,
            segmentoserp: data.segmentoserp || []
          };
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.onClose();
        });
    },
    addIDERP() {
      this.form.segmentoserp.push("");
    },
    removeIDERP(index) {
      this.form.segmentoserp.splice(index, 1);
    }
  },
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    title() {
      return this.mode == "edit" ? "Editar segmento" : "Novo segmento";
    }
  },
  created() {
    let { idsegmentocliente } = this.$route.params;
    if (idsegmentocliente !== "novo") {
      this.mode = "edit";
      this.getData(idsegmentocliente);
    }
  }
};
</script>
